import * as React from "react"
import type { SVGProps } from "react"
const SvgMailAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M4 20.71q-.82 0-1.41-.58A2 2 0 0 1 2 18.7V6.54q.07-.72.59-1.24A2 2 0 0 1 4 4.71h16q.83 0 1.41.6.53.51.58 1.23H22v6.17a1 1 0 1 1-2 0V8.6l-6.97 4.18a2 2 0 0 1-1.03.27 2 2 0 0 1-1.02-.28L4 8.6v10.13h7c.55 0 1 .52 1 1.08s-.45.92-1 .92zm15.26-14H4.75L12 11.04z"
    />
    <path d="M15 19.71h2v2q0 .43.29.72t.71.28c.42 0 .52-.1.71-.28a1 1 0 0 0 .29-.72v-2h2q.42 0 .71-.28a1 1 0 0 0 .29-.72 1 1 0 0 0-.29-.7 1 1 0 0 0-.71-.3h-2v-2a1 1 0 0 0-.29-.7 1 1 0 0 0-.71-.3 1 1 0 0 0-.71.3 1 1 0 0 0-.29.7v2h-2a1 1 0 0 0-.71.3 1 1 0 0 0-.29.7q0 .43.29.72t.71.28" />
  </svg>
)
export default SvgMailAdd
